import { _APP_CONFIG } from "../../core/config/AppConfig";
import { DataDRequest } from "../DRequest";
import { Entidad } from "../Entidad";
import { DataUtil } from "../util/Util";

import IEscuela = Entidad.IEscuela;
import IAyuda = Entidad.IAyuda;

export const _DICC_AYUDA: Map<number, IAyuda> = new Map();
const IDREQUEST = Entidad.CTipoRequest.Ayuda;

export async function _SvAyudaObtenerLista(escuelas: IEscuela[]): Promise<DataDRequest.IRequestResponseListA<IAyuda>[]> {
    const url = _APP_CONFIG.URL_RSTV2 + "ayuda/ObtenerLista";
    const currentDateStr = await DataUtil._GetMaxDate(IDREQUEST);
    const params = {
        "Modificacion": currentDateStr
    }
    return DataDRequest._Request4List(url, "GET", params, IDREQUEST)
        .then(res => [res])
        .catch(() => []);
}

export function _SvAyudaGetUrlObtenerArchivo(idAyuda: number, tamanio: 1 | 2 | 3) {
    return _APP_CONFIG.URL_RSTV2 + `ayuda/ObtenerArchivo?IdAyuda=${idAyuda}&Tamanio=${tamanio}`;
}

export function _SvAyudaGetUrlObtenerThumbnail(datoAyuda: Entidad.IAyuda, tamanio: 1 | 2 | 3) {
    return _APP_CONFIG.URL_RSTV2 + `ayuda/ObtenerImagenMini?IdAyuda=${datoAyuda.Id}&Tamanio=${tamanio}&Modificacion=${datoAyuda.Modificacion}`;
}
